Shopify.money_format="$",Shopify.formatMoney = function(money, format) {format = (typeof format !== 'string') ? this.money_format : format;money = (parseFloat(money) || 0);return format.replace(/\{\{\s*([A-Za-z_]+)\s*\}\}/, function(match, format) {var addThousandSeperator = function (m) {return m.replace(/\B(?=(\d{3})+(?!\d))/g, ',');};switch (format) {case 'amount':return money.toFixed(2);case 'amount_no_decimals':return money.toFixed(0);case 'amount_with_comma_separator':return addThousandSeperator(money.toFixed(2), ',');case 'amount_no_decimals_with_comma_separator':return addThousandSeperator(money.toFixed(0));}});}

window.theme = window.theme || {};
theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').text();

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  var shop_currency = $('#shop_currency_val').text();
  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options){

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ''));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
    });
  };

  itemAddedCallback = function (product) {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart){
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function(cart){
    // Start with a fresh cart div
    $cartContainer.empty();
    var related_html = $('.cart-related-products-part').html();

    // Show empty cart
    if(cart.item_count === 0){
      $cartContainer
        .append('<div class="block-cart-header"><div class="row align-items-center"><div class="col"><h2 class="mb-0 title text-left">Cart<svg xmlns="http://www.w3.org/2000/svg" width="7" height="9" viewBox="0 0 7 9" fill="none"><path d="M7 4.5L0.25 8.39711L0.25 0.602885L7 4.5Z" fill="black"/></svg></h2><p class="empty_cart_slide_cls">No products in your shopping bag.</p></div><div class="col col-auto"><button class="cart-close emptycartclose"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M1.83533 8.78678L0.421114 7.37257L3.20712 4.58657L0.336262 1.71572L1.80704 0.244934L4.6779 3.11579L7.47804 0.315645L8.89225 1.72986L6.09211 4.53L8.96296 7.40086L7.49218 8.87164L4.62133 6.00078L1.83533 8.78678Z" fill="white"/></svg></button></div></div>'+related_html);
      cartCallback(cart);
      return;
    }

    
    
    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_200x200$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
             delete cartItem.properties[key];
           }
        });
      }
      var options = [];       
      $.each(cartItem.options_with_values,function(i,option){
        //console.log(option);
        if(option.value == "Default Title"){

        }else{
          option = {
            option_name : option.name,
            option_value : option.value,
          }
        }        
        options.push(option);
      });      
      var carttitle = cartItem.product_title;
      if( carttitle.indexOf(' - ') != -1 ){
        var result = carttitle.split(' - ');
        var main_title = result[0];
        var colortitle = result[1];
      }
      else{
        var main_title = carttitle;
        var colortitle = '';
      } 
// console.log(cartItem, cartItem.compare_at_price);
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        mainname:main_title,
        colorname:colortitle,
        variation: cartItem.variant_title,
        optionval:options,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
//         price: Shopify.formatMoney(cartItem.price / 100, shop_currency),
//         lineprice: Shopify.formatMoney(cartItem.line_price / 100, shop_currency),
         discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), shop_currency) ,
        
        price: "€" + (cartItem.price / 100).toFixed(2).replace('.', ','),
        lineprice: "€" + (cartItem.line_price / 100).toFixed(2).replace('.', ','),
//         discountedPrice: "€" + ((cartItem.price - (cartItem.total_discount/cartItem.quantity)).toFixed(2).replace('.', ','), 
        discounts: cartItem.discounts,
        discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
        vendor: cartItem.vendor,
        type: cartItem.product_type,
        
        
      };
      items.push(item);
    });    

    
    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalitemcount:cart.item_count,
      
//       totalPrice: Shopify.formatMoney(cart.total_price / 100, shop_currency),
      
      totalPrice:"€" + (cart.total_price / 100).toFixed(2).replace('.', ','), 
      totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
    };
    

//     console.log((cartItem.price - (cartItem.total_discount/cartItem.quantity)))

    $cartContainer.append(template(data));
    cartCallback(cart);   
    
    /*$( document ).on( "swipeleft", ".swipeitem", function( event ) {
      console.log('left');
    });*/
    
    /*$(function(){
      $( ".cart-right" ).on( "swipeleft", swipeHandler );
      function swipeHandler( event ){
        $( event.target ).addClass( "swipe" );
        console.log('swipe');
      }
    });*/
    
    /*var windowSize = $(window).width();
    if(windowSize < 576){
      $('.swipeitem').each(function(e){
        var currentswipe = $(this);
        jquerySwipeHandler.handleSwipe(currentswipe, [
          jquerySwipeHandler.SWIPE_LEFT, 
          jquerySwipeHandler.SWIPE_RIGHT, 
          jquerySwipeHandler.SWIPE_DOWN, 
          jquerySwipeHandler.SWIPE_UP, 
          jquerySwipeHandler.CLICK
        ], function (direction) {          
          if(direction=='SWIPE_LEFT'){
            $(currentswipe).addClass('cartswipelist');
            $(currentswipe).find('.cart_remove_item').trigger('click');
          }
          if(direction=='SWIPE_RIGHT'){
            $(currentswipe).removeClass('cartswipelist');
          }
        });
      });
    }*/           
  };
  cartCallback = function(cart){
    $body.trigger('ajaxCart.afterCartLoad', cart);
    wc_theme_source.lib.on_cart_update(cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };
  adjustCart = function(){
    
     // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val());

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    
    $body.on('click', '.cart_remove_item', function(){
      var line = $(this).attr('data-line');
      wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
    });
    
    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });
    
    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });
    
    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback);
      }, 250);
    }
    
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      wc_theme_source.lib.get_cart(buildCart);
      isUpdating = false;
    }, 150)
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };
    
  return module;

}(ajaxCart || {}, jQuery));

  
// function translateCart() {
//   var cart = $('.cart').html();
//   var noProd = $('.no-products').html();
//   var colls = $('.collections').html();
//   var home = $('.home').html();
//   var remove = $('.remove').html();
//   var checkout = $('.checkout').html();
//   var goToCart = $('.checkout').html();
  
// $('.block-cart-header h2.title.text-left').html(cart);  
// $('.empty_cart_slide_cls').html(noProd)
// $('.cart-related-products-btn a:first-child').html(colls)
// $('cart-related-products-btn a:last-child').html(home)
// $('.cart-remove').html(remove)
// $('.empty_cart_slide_cls').html(checkout)
// }
  
// $("#cart-icon-bubble").on("click", translateCart);